import React, { useState, useEffect } from 'react';
import { Alert as BootstrapAlert } from 'react-bootstrap';

// Define error message mapping
const errorMessages = {
  email_pass_login: "Invalid email or password.",
  default_error: "An error occurred. Please try again."
};

const Alert = ({ variant, message, show, onClose, timeout = 4000, position = 'top', textAlign = 'center' }) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
    
    // Auto-dismiss after timeout if specified
    if (show && timeout) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose();
      }, timeout);
      
      return () => clearTimeout(timer);
    }
  }, [show, timeout, onClose]);

  // Get the appropriate message - either from the mapping or use the direct message
  const displayMessage = errorMessages[message] || message || errorMessages.default_error;

  if (!visible || !show) return null;

  // Define styles for different positions
  const positionStyles = {
    top: {
      position: 'fixed',
      top: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1060, // Increased from 1050 to be higher than Bootstrap's modal (1050)
      width: '90%',
      maxWidth: '500px',
    },
    bottom: {
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1060, // Increased from 1050 to be higher than Bootstrap's modal (1050)
      width: '90%',
      maxWidth: '500px',
    }
  };

  return (
    <div style={positionStyles[position]}>
      <BootstrapAlert 
        variant={variant || 'danger'} 
        onClose={() => {
          setVisible(false);
          if (onClose) onClose();
        }} 
        dismissible
        style={{ textAlign }}
      >
        {displayMessage}
      </BootstrapAlert>
    </div>
  );
};

export default Alert;